import { render, staticRenderFns } from "./ResultTeam.vue?vue&type=template&id=775d3963"
import script from "./result_team.js?vue&type=script&lang=js&external"
export * from "./result_team.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports